var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnimations({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "var(--gray-40)",
    viewBox: "0 0 64 64",
    className: "svg-icon",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.176 20.932c-1.778 3.154-2.824 6.922-2.824 10.936s1.048 7.784 2.882 11.05l-.058-.114c-.844.23-1.816.366-2.818.376h-.006c-6.238 0-11.294-5.056-11.294-11.294s5.056-11.294 11.294-11.294h.04c.988 0 1.948.124 2.864.356l-.08-.018v.002ZM9.036 24.47c-.958 2.182-1.514 4.724-1.514 7.398 0 2.674.558 5.216 1.562 7.518l-.048-.122a10.297 10.297 0 0 1-1.54-.002l.034.002a7.53 7.53 0 0 1 0-15.06c.566.056 1.078.15 1.576.28l-.07-.016v.002Zm39.906 22.588c-8.316 0-15.058-6.742-15.058-15.058 0-8.316 6.742-15.058 15.058-15.058C57.258 16.942 64 23.684 64 32c-.064 8.216-6.696 14.862-14.9 14.946h-.008l-.15.112Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimations);
export default __webpack_public_path__ + "static/media/animations.e0a7d931a9fac9476581d6af71b5348d.svg";
export { ForwardRef as ReactComponent };